import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  useEmailVerifiedMutation,
  useResendOTPMutation,
} from "../../actions/authActions";
import textWeight from "../../utils/textWeight";
export default () => {
  const [loading, setLoading] = useState("");
  const { TextWeight } = textWeight();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const emailVerified = useSelector(
    (state) => state.app.emailVerified.emailVerified
  );
  const [otp, setOtp] = useState(["", "", "", "", ""]);
  const inputRefs = useRef([]);
  const isOtpComplete = otp.every((digit) => digit !== "");
  const [timer, setTimer] = useState(60);
  const [resendDisabled, setResendDisabled] = useState(true);
  const { handleSubmit } = useForm();
  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setResendDisabled(false);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const requestVerifyOtpMutation = useResendOTPMutation(dispatch);

  const handleResendOtp = () => {
    setResendDisabled(true);
    setTimer(60); // Reset timer
    requestVerifyOtpMutation.mutate({
      email: emailVerified,
    });
  };
  const routeData = "/reset-password";
  const mutation = useEmailVerifiedMutation(setLoading, navigate, routeData);
  useEffect(() => {
    if (otp.every((digit) => digit !== "") && otp.join("").length === 5) {
      onSubmit();
    }
  }, [otp]);

  const onSubmit = () => {
    setLoading(true);
    mutation.mutate({
      email: emailVerified,
      otp: otp.join(""),
    });
  };

  const handleChange = (index, value) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(paste)) return; // Ensure only digits

    const pasteDigits = paste.slice(0, otp.length).split("");
    const newOtp = [...otp];

    pasteDigits.forEach((digit, i) => {
      newOtp[i] = digit;
      if (inputRefs.current[i]) {
        inputRefs.current[i].value = digit;
      }
    });

    setOtp(newOtp);

    const lastFilledIndex = pasteDigits.length - 1;
    if (inputRefs.current[lastFilledIndex]) {
      inputRefs.current[lastFilledIndex].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return {
    TextWeight,
    handleSubmit,
    onSubmit,
    otp,
    inputRefs,
    handleChange,
    handleKeyDown,
    handlePaste,
    formatTime,
    timer,
    handleResendOtp,
    resendDisabled,
    loading,
    isOtpComplete,
  };
};
